import React, { useEffect, useRef, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import {
	InfiniteScroll,
	PullToRefresh,
	Image,
	Grid,
	SearchBar,
	SearchBarRef,
} from "antd-mobile";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import API from "@/api";
import { showGlobalLoading } from "@/components/globalLoading";
import useCustomTranslation from "@/hooks/useTranslation";
import CustomEmpty from "@/components/Empty";
import { GameItem as GameItemType } from "../Game/type";
import useRouter from "@/hooks/useRouter";
import { useGameNavigation } from "@/hooks/useGameNavigation";
import { isEmpty } from "lodash";

const GameItem: React.FC<{ game: GameItemType }> = ({ game }) => {
	const classes = useStyles();
	const { goToPlay } = useGameNavigation();
	return (
		<div
			onClick={() => {
				goToPlay(game);
			}}
			className={classes.gameSingle}
		>
			<Image className="img" src={game.coverPic} fit="cover" />
			<div className="cont">
				<div className="name">{game.name}</div>
				<div className="play">{game.gameCompany}</div>
			</div>
		</div>
	);
};

const SearchGame: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { goBack } = useRouter();
	const { showLoading, hideLoading } = showGlobalLoading();
	const [value, setValue] = useState("");
	const searchRef = useRef<SearchBarRef>(null);
	const [data, setData] = useState<GameItemType[]>([]);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const pageSize = 15;
	const fetchListHandle = async (isRefresh = false) => {
		try {
			if (isEmpty(value)) return;
			showLoading();
			let pageNum = isRefresh ? 0 : page;
			const params: any = {
				page: pageNum,
				pageSize: pageSize,
				gameName: value,
			};
			const result: any = await API.games.apiGetGameSerch(params);
			if (result?.code === 0) {
				const contentData = result.content.data;
				const haveMore = result.content.haveMore;
				setHasMore(haveMore);
				if (haveMore) {
					if (isRefresh) {
						setPage(1);
					} else {
						setPage((prevPage) => prevPage + 1);
					}
				}
				if (pageNum === 0) {
					setData(contentData);
				} else {
					setData((prevData) => [...prevData, ...contentData]);
				}
			}
		} catch (error) {
			console.log("---postUserAgentManagerList--:", error);
		} finally {
			hideLoading();
		}
	};
	const handleRefresh = async () => {
		// 模拟刷新数据
		await fetchListHandle(true);
	};

	const handleFetchMore = async () => {
		// 模拟加载更多数据
		await fetchListHandle();
	};

	useEffect(() => {
		searchRef.current?.focus();
		fetchListHandle();
	}, []);

	return (
		<div className="router-main">
			<div className={classes.searchNavWrap}>
				<div onClick={() => goBack()} className="back">
					<Image
						src={require("@/assets/images/icons/back.png")}
						width={20}
						height={18}
					/>
				</div>
				<div className="search">
					<SearchBar
						ref={searchRef}
						value={value}
						placeholder={t("SearchGame")}
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={() => handleRefresh()}
					/>
				</div>
			</div>
			<div className={`router-view ${classes.evoListWrap}`}>
				<PullToRefresh
					onRefresh={handleRefresh}
					canReleaseText={t("canReleaseText")}
					completeText={t("completeText")}
					pullingText={t("pullingText")}
					refreshingText={t("refreshingText")}
				>
					{data.length ? (
						<Grid columns={3} gap={[16, 14]}>
							{data.map((game, index) => (
								<Grid.Item key={game.gameId}>
									<GameItem game={game} />
								</Grid.Item>
							))}
						</Grid>
					) : (
						<CustomEmpty />
					)}

					{data.length > 0 && (
						<InfiniteScroll
							loadMore={handleFetchMore}
							hasMore={hasMore}
						>
							<InfiniteScrollContent hasMore={hasMore} />
						</InfiniteScroll>
					)}
				</PullToRefresh>
			</div>
		</div>
	);
};

export default SearchGame;

const useStyles = createUseStyles({
	searchNavWrap: {
		display: "flex",
		alignItems: "center",
		padding: {
			top: pxToRem(16),
			bottom: pxToRem(16),
			right: pxToRem(20),
		},
		borderBottom: "1px solid #2F3A62",
		"& .back": {
			padding: {
				left: pxToRem(20),
				right: pxToRem(20),
			},
		},
		"& .search": {
			flex: 1,
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
	evoListWrap: {
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
	},
	gameSingle: {
		width: pxToRem(100),
		"& .img": {
			height: pxToRem(120),
			borderRadius: pxToRem(14),
			border: "1px solid #384F7A",
		},
		"& .cont": {
			paddingTop: pxToRem(6),
		},
		"& .name": {
			color: "#FFFFFF",
			fontSize: pxToRem(14),
			fontWeight: 500,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
		"& .play": {
			color: "#868FA8",
			fontSize: pxToRem(12),
			fontWeight: 400,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		},
	},
});
